/**
 * Animation Variants
 * Framer Motion animation configurations
 */

export const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

export const cardVariants = {
  hiddenLeft: {
    opacity: 0,
    x: -100,
    rotate: -8,
    scale: 0.8,
  },
  hiddenRight: {
    opacity: 0,
    x: 100,
    rotate: 8,
    scale: 0.8,
  },
  visible: custom => ({
    opacity: 1,
    x: 0,
    rotate: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 60,
      damping: 15,
      mass: 1,
      delay: custom * 0.15,
      duration: 1.5,
    },
  }),
};

export const storyCopyVariants = {
  hiddenLeft: {
    opacity: 0,
    x: -48,
  },
  hiddenRight: {
    opacity: 0,
    x: 48,
  },
  visible: custom => ({
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.7,
      delay: custom * 0.12 + 0.12,
      ease: 'easeOut',
    },
  }),
};
